export function isHtml(str: string) {
    return /<[a-z][\s\S]*>/i.test(str);
}

export function getProperty(object: any, propertyChain: string, translatePrefix = '') {
    const chain = propertyChain.split('.');
    let value: any = object;
    chain.forEach(prop => {
        if (value == null) {
            return value;
        }
        value = value[prop];
    });
    return value != null && typeof value === 'string' ? translatePrefix + value : value;
}

export function extractErrorMessage(
    error: any,
    defaultMessage: string,
): string {
    const errorBody: any = getErrorBody(error);
    let message: string;
    if (typeof errorBody === 'object') {
        if (errorBody.innererror) {
            message = errorBody.innererror.message.replace('[', '').replace(']', '');
        } else {
            message = (isHtml(errorBody.message) || typeof errorBody.message !== 'string') ? defaultMessage : errorBody.message;
        }
    } else {
        message = defaultMessage;
    }

    const errorCode = extractErrorCode(error);
    return (!errorCode) ? message : `${message} (#${errorCode})`;
}

export function extractErrorCode(error: any): any {
    let errorCode: any;
    try {
        const errorBody: any = getErrorBody(error);
        errorCode = errorBody.errorCode || (errorBody.error ? errorBody.error.code : errorBody.code);
    } catch (e) {
        errorCode = null;
    }
    return errorCode;
}

function getErrorBody(error: any) {
    return getProperty(error, 'error.error')
        || getProperty(error, 'error')
        || error;
}
